import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, UntypedFormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FirebaseService } from '../../../../service/firebase.service';
import { UserserviceService } from '../../services/userservice.service';

@Component({
  selector: 'app-updatepassword',
  templateUrl: './updatepassword.component.html',
  styleUrls: ['./updatepassword.component.scss']
})
export class UpdatepasswordComponent implements OnInit {
  public currentPasswordControl = new UntypedFormControl('', Validators.required);
  public newPasswordControl = new UntypedFormControl('', Validators.required);
  public confirmNewPasswordControl = new UntypedFormControl('', [Validators.required, this.matchPassword()]);

  public newPassword: string = "";
  public confirmNewPassword: string = "";

  constructor(private userService: UserserviceService, private _firebaseService: FirebaseService, private _snackbar: MatSnackBar) { }


  ngOnInit(): void {
  }

  checkPassword() {
  }
  matchPassword(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      let res;
      if (!value) {
        res = null;
      }

   //   if (this.confirmNewPasswordControl)
    //  console.log(this.newPassword, this.confirmNewPassword, )

      if (this.confirmNewPasswordControl) {
        if (this.newPassword == this.confirmNewPasswordControl.value) {
          // control.valid = true;
          res = null
        }
        else {
          res = { notEqual: true } 
        }
      }



     // console.log(res);
      return res
    }
  }


  update() {
    this.currentPasswordControl.markAllAsTouched();
    this.newPasswordControl.markAllAsTouched();
    this.confirmNewPasswordControl.markAllAsTouched();

    if (this.currentPasswordControl.valid && this.newPasswordControl.valid && this.confirmNewPasswordControl.valid) {
      //console.log("VALID FORM")
      this.userService.checkUserEmail(this._firebaseService.user.email, this.currentPasswordControl.value).then(d => {
        this.userService.updatePassword(this.newPasswordControl.value).then(d => {
       //   console.log("PASSWORD CHANGE")

          this._snackbar.open("Modification du mot de passe validé",'OK' ,{duration: 5000})
        }).catch(err => {
          console.log(`Error: ${err}`)
        })

        this.currentPasswordControl.reset()
        this.newPasswordControl.reset()
        this.confirmNewPasswordControl.reset()

      }).catch(err => {
        this.currentPasswordControl.setErrors({incorrectPassword: true})
      })




    }
    else {
      console.log("INVALID FORM")
    }
  }

}
